module.exports = __webpack_public_path__ + "static/media/cheesepizza.aaed4892.jpg";